export function createQueryString(params: { [key: string]: string }): string {
  return new URLSearchParams(Object.entries(params)).toString();
}
